function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3456 11.4234L8.6759 1.6033C8.45446 1.21989 8.12267 1 7.76558 1C7.40839 1 7.07659 1.21989 6.85526 1.6033L1.18561 11.4234C0.964271 11.8067 0.939701 12.2041 1.1183 12.5134C1.29679 12.8226 1.65316 13 2.09583 13H13.4352C13.878 13 14.2343 12.8226 14.4129 12.5134C14.5915 12.204 14.5669 11.8067 14.3456 11.4234ZM13.7262 12.1168C13.7002 12.1617 13.6002 12.2071 13.4352 12.2071H2.09593C1.93086 12.2071 1.83093 12.1618 1.80501 12.1168C1.779 12.0719 1.78984 11.9627 1.87232 11.8198L7.54197 1.99972C7.62446 1.85685 7.71365 1.79295 7.76548 1.79295C7.8174 1.79295 7.9067 1.85685 7.98919 1.99972L13.6588 11.8198C13.7413 11.9627 13.7522 12.0719 13.7262 12.1168Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.76556 4.29297L7.76556 8.35232",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.76556 10.3818L7.76556 11.0584",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round"
});

function SvgAttentionicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionicon);
export default __webpack_public_path__ + "static/media/attention.icon.9ef2d70b.svg";
export { ForwardRef as ReactComponent };